if (!customElements.get('boom-tab-banner')) {
  class BoomTabBanner extends HTMLElement {
    connectedCallback() {
      this.initTabBanner();
    }

    initTabBanner() {
      const tabs = this.querySelectorAll('.boom-tab-item');
      const tabWrapper = this.querySelector('.boom-tab-wrapper');
      const slides = this.querySelectorAll('.boom-banner-slide');
      const prevBtn = this.querySelector('.boom-prev-btn');
      const nextBtn = this.querySelector('.boom-next-btn');

      if (!tabs.length || !slides.length) return;

      let currentIndex = 0;
      const totalSlides = slides.length;
      let autoplayTimer = null;
      const autoplayEnabled = this.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5000;

      function switchSlide(index) {
        if (index < 0) index = totalSlides - 1;
        if (index >= totalSlides) index = 0;
        currentIndex = index;

        tabs.forEach((tab, i) => {
          if (i === currentIndex) {
            tab.classList.add('active');
          } else {
            tab.classList.remove('active');
          }
        });

        slides.forEach((slide, i) => {
          if (i === currentIndex) {
            slide.classList.remove('opacity-0', 'pointer-events-none');
            slide.classList.add('opacity-100', 'z-10');
          } else {
            slide.classList.add('opacity-0', 'pointer-events-none');
            slide.classList.remove('opacity-100', 'z-10');
          }
        });

        centerTab(tabs[currentIndex]);
      }

      // 手机端横向滚动时，将选中的 Tab 滚动到中间，保证左右两侧 Tab 可见
      function centerTab(tab) {
        if (!tab || !tabWrapper) return;
        if (tabWrapper.scrollWidth <= tabWrapper.clientWidth + 1) return;

        const wrapRect = tabWrapper.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const delta = (tabRect.left - wrapRect.left) - (wrapRect.width - tabRect.width) / 2;
        tabWrapper.scrollTo({ left: tabWrapper.scrollLeft + delta, behavior: 'smooth' });
      }

      function startAutoplay() {
        if (!autoplayEnabled) return;
        autoplayTimer = setInterval(() => {
          switchSlide(currentIndex + 1);
        }, autoplaySpeed);
      }

      function resetAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          startAutoplay();
        }
      }

      // 点击 Tab 切换
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          switchSlide(i);
          resetAutoplay();
        });
      });

      // 左右按钮事件
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          switchSlide(currentIndex - 1);
          resetAutoplay();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          switchSlide(currentIndex + 1);
          resetAutoplay();
        });
      }

      startAutoplay();
    }
  }

  customElements.define('boom-tab-banner', BoomTabBanner);
}
